import Chart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import { format } from "date-fns";
import localeBr from "date-fns/locale/pt-BR";

import { Container } from "./styles";

function orderWeekDay() {
  const days = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"];
  const now = new Date();
  const past = days.slice(now.getDay() + 1, days.length);
  const actual = days.slice(0, now.getDay() + 1);
  return past.concat(actual);
}

const options: ApexOptions = {
  colors: ["var(--primary)", "white"],
  stroke: {
    curve: "straight",
    width: 2,
  },
  chart: {
    toolbar: {
      show: false,
    },

    zoom: {
      enabled: false,
    },
    foreColor: "white",
    width: "100%",
    height: "100%",
  },
  grid: {
    show: true,
    borderColor: "var(--grey-300)",
  },
  dataLabels: {
    enabled: false,
  },
  tooltip: {
    enabled: true,
    style: {
      fontFamily: "Inter",
    },
    custom: function ({ series, seriesIndex, dataPointIndex, w }) {
      const date = new Date();

      const dateToSubtract = w.globals.categoryLabels.length - 1;
      date.setDate(date.getDate() - (dateToSubtract - dataPointIndex));

      return `<div class="chartTooltip">
          <header>
            <span>${format(date, "dd MMM, iiii", { locale: localeBr })}</span>
          </header>
          <div>
            <span>Total</span>
            <span>${series[seriesIndex][dataPointIndex]}</span>
          </div>
        </div>`;
    },
  },

  xaxis: {
    type: "category",
    axisBorder: {
      show: false,
    },
    axisTicks: {
      show: false,
    },
    categories: orderWeekDay(),
    labels: {
      style: {
        colors: "var(--white)",
        fontFamily: "Inter",
        fontSize: "16px",
        fontWeight: "normal",
      },
    },
  },
  yaxis: {
    tickAmount: 5,
    labels: {
      style: {
        colors: "var(--white)",
        fontFamily: "Inter",
        fontSize: "16px",
        fontWeight: "500",
      },
    },
  },
  fill: {
    opacity: 0.3,
    type: "gradient",
    gradient: {
      opacityFrom: 0.7,
      opacityTo: 0.3,
    },
  },
  legend: {
    show: true,
    position: "top",
    fontFamily: "Inter",
    horizontalAlign: "right",
    fontSize: "14px",
    itemMargin: {
      horizontal: 13,
    },
  },
  title: {
    text: "Ocorrências na semana",
    align: "left",
    style: {
      fontFamily: "DM Sans",
      fontSize: "18px",
      fontWeight: "500",
    },
  },
};

interface ChartProps {
  vehicle?: number[];
  residence?: number[];
}

export function LineChart({ vehicle, residence }: ChartProps) {
  const series = [
    { name: "Veículos", data: vehicle ? vehicle : [] },
    { name: "Estabelecimentos", data: residence ? residence : [] },
  ];

  // Dados hardcoded para teste do gráfico.
  // Comente a lista de cima antes de descomentar essa de baixo.
  // const series = [
  //   {
  //     name: "Veículos",
  //     data: [
  //       10,
  //       30,
  //       4,
  //       5,
  //       12,
  //       23,
  //       8
  //     ]
  //   },
  //   {
  //     name: "Estabelecimentos",
  //     data: [
  //       40,
  //       12,
  //       4,
  //       23,
  //       12,
  //       42,
  //       6
  //     ]
  //   }
  // ]

  return (
    <Container>
      <Chart
        options={options}
        series={series}
        width={"100%"}
        height={320}
        type="area"
      />
    </Container>
  );
}
